module.exports = __webpack_public_path__ + "media/a7.f37ad7e0.mp3";